import React from 'react';
import { Modal } from '@testsigma/atoms';
import {
  MetadataConnectionCreateForm,
  MetadataConnectionEditForm,
  MetadataConnectionDetailsForm,
  MetadataConnectionFailedScreen,
  MetadataConnectionUpdateSuccessScreen,
  MetadataSyncScreen,
  MetadataPollingScreen,
  MetadataSyncFailure,
  MetadataSyncSuccess,
  MetadataConnectionSelectForm,
  MetadataConnectionDuplication,
} from '../components/connection-modal-screens';
import {
  MetadataConnectionModalScreens,
  useSFConnectionState,
} from '@contexts/sf-connection-context';
import { PrepareMetadataSyncStarted } from '../components/select-connection/preparing-metadata-screen';
import { TestConnectionSuccessModal } from '../components/connection-modal-screens/test-connection-success-modal';
import { StandardObjectsSyncedScreen } from '../components/refresh-metadata-modal-screens/standard-objects-synced-screen';
import { MetadataSyncPartiallySuccessful } from '../components/refresh-metadata-modal-screens/metadata-sync-partially-successful';
import classNames from 'classnames';

export const MetadataConnectionModal: React.FC = () => {
  const { overlayMode, metadataConnectionModalScreen, selectedConnection } =
    useSFConnectionState();

  if (overlayMode !== 'metadata_connection') {
    return null;
  }

  return (
    <Modal
      closeOnEscape={false}
      closeOnOutsideClick={false}
      isOpen={overlayMode === 'metadata_connection'}
      className={classNames('!rounded-lg !p-0 !w-150', {
        '!w-[450px]':
          metadataConnectionModalScreen ===
          MetadataConnectionModalScreens.METADATA_SYNC_PARTIALLY_SUCCESSFUL_SCREEN,
      })}
    >
      {metadataConnectionModalScreen ===
        MetadataConnectionModalScreens.CONNECTION_CREATE_SCREEN && (
        <MetadataConnectionCreateForm />
      )}
      {metadataConnectionModalScreen ===
        MetadataConnectionModalScreens.CONNECTION_DETAILS_SCREEN && (
        <MetadataConnectionDetailsForm />
      )}
      {metadataConnectionModalScreen ===
        MetadataConnectionModalScreens.CONNECTION_EDIT_SCREEN && (
        <MetadataConnectionEditForm />
      )}
      {metadataConnectionModalScreen ===
        MetadataConnectionModalScreens.CONNECTION_UPDATE_SUCCESS_SCREEN && (
        <MetadataConnectionUpdateSuccessScreen />
      )}

      {metadataConnectionModalScreen ===
        MetadataConnectionModalScreens.CONNECTION_AUTH_FAILURE_SCREEN && (
        <MetadataConnectionFailedScreen />
      )}

      {metadataConnectionModalScreen ===
        MetadataConnectionModalScreens.METADATA_SYNC_START_SCREEN &&
        !selectedConnection?.isDuplicate && <MetadataSyncScreen />}
      {metadataConnectionModalScreen ===
        MetadataConnectionModalScreens.METADATA_SYNC_POLLING_SCREEN && (
        <MetadataPollingScreen />
      )}
      {metadataConnectionModalScreen ===
        MetadataConnectionModalScreens.METADATA_SYNC_SUCCESSFUL_SCREEN &&
        !selectedConnection?.isDuplicate && <MetadataSyncSuccess />}

      {metadataConnectionModalScreen ===
        MetadataConnectionModalScreens.METADATA_SYNC_FAILURE_SCREEN && (
        <MetadataSyncFailure />
      )}

      {metadataConnectionModalScreen ===
        MetadataConnectionModalScreens.CONNECTION_SELECT_SCREEN && (
        <MetadataConnectionSelectForm />
      )}

      {metadataConnectionModalScreen ===
        MetadataConnectionModalScreens.METADATA_SYNC_DUPLICATE_SCREEN && (
        <MetadataConnectionDuplication />
      )}

      {metadataConnectionModalScreen ===
        MetadataConnectionModalScreens.METADATA_SYNC_DATA_PREPARATION_SCREEN && (
        <PrepareMetadataSyncStarted />
      )}

      {metadataConnectionModalScreen ===
        MetadataConnectionModalScreens.METADATA_TEST_SUCCESSFUL && (
        <TestConnectionSuccessModal />
      )}

      {metadataConnectionModalScreen ===
        MetadataConnectionModalScreens.METADATA_SYNC_PARTIALLY_SUCCESSFUL_SCREEN && (
        <MetadataSyncPartiallySuccessful />
      )}
    </Modal>
  );
};
